"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.paddingOnFocusDefault = exports.paddingOnFocusCompact = exports.paddingOnFocusComfortable = exports.compactDensity = exports.comfortableDensity = exports.defaultDensity = void 0;

var _stylitas = require("@creditas/stylitas");

const defaultDensity = ({
  size
}) => size === 'default' && (0, _stylitas.css)`
    max-height: 56px;
    padding: 16px;
  `;

exports.defaultDensity = defaultDensity;

const comfortableDensity = ({
  size
}) => size === 'comfortable' && (0, _stylitas.css)`
    max-height: 40px;
    padding: 8px 16px;
  `;

exports.comfortableDensity = comfortableDensity;

const compactDensity = ({
  size
}) => size === 'compact' && (0, _stylitas.css)`
    max-height: 32px;
    padding: 4px 16px;
  `;

exports.compactDensity = compactDensity;

const paddingOnFocusComfortable = ({
  size,
  inputFocus,
  readOnly
}) => inputFocus && !readOnly && size === 'comfortable' && (0, _stylitas.css)`
    padding: 7px 15px;
  `;

exports.paddingOnFocusComfortable = paddingOnFocusComfortable;

const paddingOnFocusCompact = ({
  size,
  inputFocus,
  readOnly
}) => inputFocus && !readOnly && size === 'compact' && (0, _stylitas.css)`
    padding: 3px 15px;
  `;

exports.paddingOnFocusCompact = paddingOnFocusCompact;

const paddingOnFocusDefault = ({
  size,
  inputFocus,
  readOnly
}) => inputFocus && !readOnly && size === 'default' && (0, _stylitas.css)`
    padding: 15px;
  `;

exports.paddingOnFocusDefault = paddingOnFocusDefault;